import { Navigate } from 'react-router-dom';

import { lazyImport } from '../utils/lazyImport';

const { AuthRoutes } = lazyImport(
  () => import('@/features/Auth/routes'),
  'AuthRoutes',
);

/**
 * routes for non-authenticated users only
 */
export const routesForNotAuthenticatedOnly = [
  {
    path: '/auth/*',
    element: <AuthRoutes />,
  },
  { path: '*', element: <Navigate to="/auth/login" /> },
];
